export default {
	ADD_TEAM_REQUEST: 'ADD_TEAM_REQUEST',
	ADD_TEAM_SUCCESS: 'ADD_TEAM_SUCCESS',
	ADD_TEAM_FAILURE: 'ADD_TEAM_FAILURE',
	EDIT_TEAM_REQUEST: 'EDIT_TEAM_REQUEST',
	EDIT_TEAM_SUCCESS: 'EDIT_TEAM_SUCCESS',
	EDIT_TEAM_FAILURE: 'EDIT_TEAM_FAILURE',
	BROWSE_TEAM_REQUEST: 'BROWSE_TEAM_REQUEST',
	BROWSE_TEAM_SUCCESS: 'BROWSE_TEAM_SUCCESS',
	BROWSE_TEAM_FAILURE: 'BROWSE_TEAM_FAILURE',
	READ_TEAM_REQUEST: 'READ_TEAM_REQUEST',
	READ_TEAM_SUCCESS: 'READ_TEAM_SUCCESS',
	READ_TEAM_FAILURE: 'READ_TEAM_FAILURE',
	LISTEN_TEAM_REQUEST: 'LISTEN_TEAM_REQUEST',
	LISTEN_TEAM_SUCCESS: 'LISTEN_TEAM_SUCCESS',
	LISTEN_TEAM_FAILURE: 'LISTEN_TEAM_FAILURE',

	// TEAM CODE
	VERIFY_TEAM_CODE_REQUEST: 'VERIFY_TEAM_CODE_REQUEST',
	VERIFY_TEAM_CODE_SUCCESS: 'VERIFY_TEAM_CODE_SUCCESS',
	VERIFY_TEAM_CODE_FAILURE: 'VERIFY_TEAM_CODE_FAILURE',

	//MEMBERS
	ADD_MEMBER_REQUEST: 'ADD_MEMBER_REQUEST',
	ADD_MEMBER_SUCCESS: 'ADD_MEMBER_SUCCESS',
	ADD_MEMBER_FAILURE: 'ADD_MEMBER_FAILURE',
	EDIT_MEMBER_REQUEST: 'EDIT_MEMBER_REQUEST',
	EDIT_MEMBER_SUCCESS: 'EDIT_MEMBER_SUCCESS',
	EDIT_MEMBER_FAILURE: 'EDIT_MEMBER_FAILURE',
	BROWSE_MEMBER_REQUEST: 'BROWSE_MEMBER_REQUEST',
	BROWSE_MEMBER_SUCCESS: 'BROWSE_MEMBER_SUCCESS',
	BROWSE_MEMBER_FAILURE: 'BROWSE_MEMBER_FAILURE',
	LISTEN_MEMBER_REQUEST: 'LISTEN_MEMBER_REQUEST',
	LISTEN_MEMBER_SUCCESS: 'LISTEN_MEMBER_SUCCESS',
	LISTEN_MEMBER_FAILURE: 'LISTEN_MEMBER_FAILURE',

	//NON_API
	RESET_TEAMS: 'RESET_TEAMS',
	RESET_MEMBERS: 'RESET_MEMBERS',
	CLEAR_STATES: 'CLEAR_STATES',
}